import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { APPLICATIONS_RENDER, APPLICATIONS_RENDER_ENG } from 'entities/application/constants';
import { ListHeadingStyled } from 'entities/application/ui/TemplatesList/TemplatesList.styles';
import { ApplicationListItemM } from '../ApplicationListItemM/ApplicationListItemM';
import { ApplicationsListContainerStyled } from './ApplicationsListM.styles';

export const ApplicationsListM: FC = () => {
	const { t, i18n } = useTranslation();

	const applications = i18n.language === `ru-RU` ? APPLICATIONS_RENDER : APPLICATIONS_RENDER_ENG;

	return (
		<ApplicationsListContainerStyled>
			<ListHeadingStyled>{t(`Marketplace_Application_Catalog`)}</ListHeadingStyled>
			{applications.map(app => (
				<ApplicationListItemM
					key={app.id}
					logoUrl={app.logoUrl}
					name={app.shortName ? app.shortName : app.name}
					description={app.description}
					applicationId={app.id}
					status={app.status}
					descriptionCard={app.descriptionCard}
				/>
			))}
		</ApplicationsListContainerStyled>
	);
};
